import { render, staticRenderFns } from "./RegistrationDialog.vue?vue&type=template&id=d435aa14"
import script from "./RegistrationDialog.vue?vue&type=script&lang=js"
export * from "./RegistrationDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports